module.exports = __webpack_public_path__ + "static/media/galeryGrass8.2dc304dc.jpg";